import apiClient from '../api/client';

export interface BusinessUnit {
  guid: string;
  name: string;
  code: string;
  active?: boolean;
}

export const getMyBusinessUnits = async (userGuid: string): Promise<BusinessUnit[]> => {
  if (!userGuid) {
    return [];
  }
  const response = await apiClient.get<BusinessUnit[]>(`/api/BusinessUnit/MyBusinessUnits?userGuid=${userGuid}`);
  return response.data;
};

export const getAllBusinessUnits = async (): Promise<BusinessUnit[]> => {
  const response = await apiClient.get<BusinessUnit[]>('/api/BusinessUnit/GetAll');
  return response.data;
};

export const createBusinessUnit = async (bu: Partial<BusinessUnit>): Promise<BusinessUnit> => {
  const response = await apiClient.post<BusinessUnit>('/api/BusinessUnit', bu);
  return response.data;
};

export const updateBusinessUnit = async (guid: string, bu: Partial<BusinessUnit>): Promise<void> => {
  await apiClient.put(`/api/BusinessUnit/${guid}`, bu);
};

export const toggleBusinessUnitStatus = async (guid: string, active: boolean): Promise<void> => {
  await apiClient.put(`/api/BusinessUnit/ToggleStatus/${guid}`, active);
};

export const getAssignedUsersForBusinessUnit = async (guid: string): Promise<string[]> => {
  const response = await apiClient.get<string[]>(`/api/BusinessUnit/${guid}/Users`);
  return response.data;
};

export const assignUsersToBusinessUnit = async (guid: string, userGuids: string[]): Promise<void> => {
  await apiClient.post(`/api/BusinessUnit/${guid}/Users`, userGuids);
};
